import React from 'react'
import './About.css';
function About() {
    return (
        <div className="about-container">
            <div className="container">
          <div className="container row">
 <div className="col-sm-12 col-lg-10 col">
 <h1>We empower innovators
by delivering access to the financial system</h1>
 </div>

 <div className="col-sm-12 col-lg-4 col ">
<h4>Our Vision</h4>
 </div>

 <div className="col-sm-12 col-lg-8 col">
<p>Our main goal is to build beautiful consumer experiences along with developer-friendly infrastructure. The result is an intelligent tool that gives everyone the ability to create amazing products that solve big problems. We are deeply focused on democratizing financial services through technology</p>
 </div>
 <div className="col-sm-12 col-lg-4 col ">
<h4>Our Business</h4>
 </div>

 <div className="col-sm-12 col-lg-8 col">
<p>At the core of our platform is the technical infrastructure APIs that connect consumers. Our innovative product provides key insights for businesses and individuals, as well as robust reporting for traditional financial institutions and developers.</p>
 </div>

          </div>

            </div>
            <div className="img-container">
    
</div>

<div className="container">

<div className="row members">
    <div className="col-sm-12 col-sm-4">
        <h5>Team Members</h5>
     <span className="num">
         300+
     </span>
    </div>

  
    <div className="col-sm-12 col-sm-4">
        <h5>Offices in the US</h5>
     <span className="num">
         3
     </span>
    </div>

    <div className="col-sm-12 col-sm-4">
        <h5>Transaction Analyzed</h5>
     <span className="num">
         10M+
     </span>
    </div>
</div>

<div className="container row">


 <div className="col-sm-12 col-lg-4 col ">
<h4>The Culture</h4>
 </div>

 <div className="col-sm-12 col-lg-8 col">
<p>We strongly believe there's always an opportunity to learn from each other outside of
day-to-day work, whether it's company-wide offsites, internal hackathons, or co-worker meetups. We always value cross-team collaboration and diversity of thought, no matter the job title.</p>
 </div>
 <div className="col-sm-12 col-lg-4 col ">
<h4>The People</h4>
 </div>

 <div className="col-sm-12 col-lg-8 col">
<p>We're all passionate about building a more efficient and inclusive financial infrastructure together. At PayAPI, we have diverse backgrounds and skills.</p>
 </div>
</div>
</div>
        </div>
    )
}

export default About
